export default function redirect(historyObject, path) {
  historyObject.push(path);
}
